import dayjs from "dayjs";
import isEmpty from "lodash/isEmpty";
import Utils from "../Utils";
import router from "../router";
import services from "../services";
import i18n from "./../i18n";

const strict = true;

const getDefaultState = () => {
  return {
    toSearch: "",
    multiSelectConfig: {
      items: [],
      activeItems: []
    },
    numberOfBills: 0,
    sortConfig: {
      descending: [true],
      sortBy: ["updatedAt"]
    },
    dateConfig: {
      range: {
        dateFrom: null,
        dateTo: null
      },
      dateToUse: "LASTUPDATE"
    },
    pagination: {
      page: 1,
      size: 10,
      isPaginationClicked: false
    },
    filterCriteriaResults: "",
    bills: [],
    activeBillId: null,
    activeBill: null,
    activeRelatedBills: [],
    variazioneBillInDialog: {},
    activeBillInfo: null,
    activeProvidedService: null,
    lastPathLocation: null,
    validProvidedServices: [],
    numOfValidProvidedServices: 0,
    numOfCompletedProvidedServices: 0,
    numbOfDraftBills: 0,
    numbOfSentBackBills: 0,
    isBillSuspended: false
  };
};

const state = getDefaultState();

const getters = {
  items: state => state.bills,
  toSearch: state => state.toSearch,
  multiSelectFullList: state => state.multiSelectConfig.items,
  multiSelectActiveList: state => state.multiSelectConfig.activeItems,
  order: state => state.sortConfig,
  dateRange: state => state.dateConfig.range,
  dateToUse: state => state.dateConfig.dateToUse,
  filterCriteriaResults: state => state.filterCriteriaResults,
  totalItems: state => state.numberOfBills,
  bills: state => state.bills,
  activeBillId: state => state.activeBillId,
  activeBill: state => state.activeBill,
  activeRelatedBills: state => state.activeRelatedBills,
  variazioneBillInDialog: state => state.variazioneBillInDialog,
  activeBillInfo: state => state.activeBillInfo,
  activeProvidedService: state => state.activeProvidedService,
  page: state => state.pagination.page,
  size: state => state.pagination.size,
  getLastPathLocation: state => state.lastPathLocation,
  // - all the provided services for a NORMAL bill type
  // - all the provided services filtered without the VARIED ones for a VARIED bill type (filterProvidedServicesOfVariedBill into bills.js)
  getValidProvidedServices: state => state.validProvidedServices,
  getNumOfValidProvidedServices: state => state.numOfValidProvidedServices,
  getNumOfCompletedProvidedServices: state =>
    state.numOfCompletedProvidedServices,
  getNumOfSentBackBills: state => state.numbOfSentBackBills,
  getNumOfDraftBills: state => state.numbOfDraftBills,
  getIsSuspended: state => state.isBillSuspended
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_TO_SEARCH(state, toSearch) {
    state.toSearch = toSearch;
    state.pagination.isPaginationClicked = false;
  },
  SET_MULTI_SELECT_ACTIVE_LIST(state, multiSelectItem) {
    let allAccettataItems = [
      "ACCEPTED",
      "VERIFIED",
      "UNVERIFIED",
      "TOPAY",
      "INPAYMENT"
    ];
    let allPagataItems = ["CROTOBECONFIRMED", "PAID", "CLOSED"];
    if (
      multiSelectItem.includes("ACCEPTED") &&
      !multiSelectItem.includes("VERIFIED")
    ) {
      multiSelectItem.splice(
        multiSelectItem.indexOf("ACCEPTED"),
        1,
        ...allAccettataItems
      );
    }
    if (
      multiSelectItem.includes("CROTOBECONFIRMED") &&
      !multiSelectItem.includes("PAID")
    ) {
      multiSelectItem.splice(
        multiSelectItem.indexOf("CROTOBECONFIRMED"),
        1,
        ...allPagataItems
      );
    }
    state.multiSelectConfig.activeItems = multiSelectItem;
    state.pagination.isPaginationClicked = false;
  },
  SET_IS_BILL_SUSPENDED(state, value) {
    state.isBillSuspended = value;
  },
  SET_MULTI_SELECT_FULL_LIST(state, isBillSuspended) {
    let items;
    if (isBillSuspended) items = ["SENTBACK"];
    else
      items = [
        "DRAFT",
        "SENT",
        "RESENT",
        "ACCEPTED",
        "CROTOBECONFIRMED",
        "UNPAID"
      ];
    state.multiSelectConfig.items = items;
  },
  REMOVE_MULTI_SELECT_ITEM(state, item) {
    let activeItems = state.multiSelectConfig.activeItems;
    if (item === "ACCEPTED") {
      activeItems.splice(activeItems.indexOf("ACCEPTED"), 1);
      activeItems.splice(activeItems.indexOf("VERIFIED"), 1);
      activeItems.splice(activeItems.indexOf("UNVERIFIED"), 1);
      activeItems.splice(activeItems.indexOf("TOPAY"), 1);
      activeItems.splice(activeItems.indexOf("INPAYMENT"), 1);
    } else if (item === "CROTOBECONFIRMED") {
      activeItems.splice(activeItems.indexOf("CROTOBECONFIRMED"), 1);
      activeItems.splice(activeItems.indexOf("PAID"), 1);
      activeItems.splice(activeItems.indexOf("CLOSED"), 1);
    } else {
      let index = activeItems.findIndex(i => i === item);
      activeItems.splice(index, 1);
    }
  },
  SET_ORDER(state, order) {
    state.sortConfig = order;
    state.pagination.isPaginationClicked = false;
  },
  updateDateRange(state, dateRange) {
    state.dateConfig.range = dateRange;
    state.pagination.isPaginationClicked = false;
  },
  SET_FILTER_CRITERIA_RESULTS(state) {
    let criteria = [];
    if (state.toSearch) {
      criteria.push("'" + state.toSearch + "'");
    }

    let activeMultiSelectItems = state.multiSelectConfig.activeItems;
    if (!isEmpty(activeMultiSelectItems)) {
      let allAccettataItems = [
        "ACCEPTED",
        "VERIFIED",
        "UNVERIFIED",
        "TOPAY",
        "INPAYMENT"
      ];
      let allPagataItems = ["CROTOBECONFIRMED", "PAID", "CLOSED"];
      let translatedActiveItems = [];
      activeMultiSelectItems.forEach(item => {
        if (allAccettataItems.includes(item)) {
          translatedActiveItems.push(
            i18n.t(`baseFilters.bills.ACCEPTEDCheckbox`).toUpperCase()
          );
        } else if (allPagataItems.includes(item)) {
          translatedActiveItems.push(
            i18n.t(`baseFilters.bills.CROTOBECONFIRMEDCheckbox`).toUpperCase()
          );
        } else {
          translatedActiveItems.push(
            i18n.t(`baseFilters.bills.${item}Checkbox`).toUpperCase()
          );
        }
      });
      let uniqueTranslatedActiveItems = [...new Set(translatedActiveItems)];
      criteria.push("'" + uniqueTranslatedActiveItems.join(", ") + "'");
    }

    let dateFrom = state.dateConfig.range.dateFrom;
    let dateTo = state.dateConfig.range.dateTo;

    if (dateFrom || dateTo) {
      let dateFormat = "DD/MM/YYYY";
      let formatDateFrom = dateFrom ? dayjs(dateFrom).format(dateFormat) : "";
      let formatDateTo = dateTo ? dayjs(dateTo).format(dateFormat) : "";
      criteria.push("'" + formatDateFrom + " - " + formatDateTo + "'");
    }

    state.filterCriteriaResults = criteria.join(" & ");
  },
  SET_BILLS(state, bills) {
    state.bills = bills;
  },
  SET_NUMBER_OF_BILLS(state, numberOfBills) {
    state.numberOfBills = numberOfBills;
  },
  SET_ACTIVE_BILL_ID(state, billId) {
    state.activeBillId = billId;
  },
  SET_ACTIVE_BILL(state, responseObj) {
    if (responseObj) {
      state.activeBill = responseObj.bill;
      state.activeRelatedBills = responseObj.relatedBills;
    } else {
      state.activeBill = null;
      state.activeRelatedBills = [];
    }
  },
  SET_VALID_PROVIDED_SERVICES(state) {
    let pss = state.activeBill ? state.activeBill.providedServices : [];
    if (state.activeBill && state.activeBill.billType === "VARIED") {
      pss = state.activeBill ? state.activeBill.filteredProvidedServices : [];
    }
    if (!pss || !Array.isArray(pss) || pss.length === 0) {
      state.validProvidedServices = [];
      state.numOfValidProvidedServices = 0;
    } else {
      let copy = [...pss];
      // fondoest/issues#908
      if (state.activeBill.billState === "DRAFT") {
        // extract completed provided services, removing from original list of provided services
        let completedPs = copy.filter((ps, i) => {
          if (
            ps?.invoiceNumber &&
            ps?.invoiceDate &&
            ps?.invoiceTotal &&
            ps?.providedServiceDocument
          ) {
            copy.splice(i, 1);
            return true;
          }
          return false;
        });
        if (completedPs.length > 0) {
          // apply alphabetic order on the list of completed provided services
          completedPs = applyAlphabeticOrderOnProvidedServices(completedPs);
          // apply alphabetic order on the list of not completed provided services
          copy = applyAlphabeticOrderOnProvidedServices(copy);
          // join the two lists of provided services, putting at the end the completed one
          state.validProvidedServices = [...copy, ...completedPs];
        } else {
          // apply alphabetic order on the list of not completed provided services
          state.validProvidedServices =
            applyAlphabeticOrderOnProvidedServices(copy);
        }
      } else if (state.activeBill.billState === "SENTBACK") {
        if (copy.some(e => e.state === "CHECKED_KO")) {
          let order = { CHECKED_KO: 1 };
          state.validProvidedServices = copy.sort(
            (a, b) =>
              (order[a.state] || Number.MAX_VALUE) -
                (order[b.state] || Number.MAX_VALUE) ||
              a.serviceName.localeCompare(b.serviceName) ||
              a.providedServiceId.localeCompare(b.providedServiceId)
          );
        } else {
          state.validProvidedServices =
            applyAlphabeticOrderOnProvidedServices(copy);
        }
      } else {
        state.validProvidedServices =
          applyAlphabeticOrderOnProvidedServices(copy);
      }
    }
    state.numOfValidProvidedServices = state.validProvidedServices.length;
  },
  SET_NUM_OF_COMPLETED_PROVIDED_SERVICES(state) {
    if (state.activeBill) {
      if (state.activeBill.billState === "DRAFT") {
        // If the bill is in DRAFT state, all the valid provided services have the CREATED state.
        // The CREATED provided service is complete if it has all these properties:
        // invoice number, invoice date, invoice total and fascicolo doc.
        // invoice doc and prescription doc are not checked because could be null if they are "uploaded" with documentone
        let pss = state.validProvidedServices.filter(ps => {
          return (
            ps?.invoiceNumber &&
            ps?.invoiceDate &&
            ps?.invoiceTotal &&
            ps?.providedServiceDocument
          );
        });
        if (pss) {
          state.numOfCompletedProvidedServices = pss.length;
        } else {
          state.numOfCompletedProvidedServices = 0;
        }
      } else if (state.activeBill.billState === "SENTBACK") {
        // If the bill is in SENTBACK state, all the valid provided services could have the CREATED, CORRECTED or CHECKED_OK state.
        // The provided service in one of that state is complete if it has all these properties:
        // invoice number, invoice date, invoice total and fascicolo doc
        // invoice doc and prescription doc are not checked because could be null if they are "uploaded" with documentone
        let filteredPss = state.validProvidedServices.filter(ps => {
          return (
            ps.state === "CREATED" ||
            ps.state === "CHECKED_OK" ||
            ps.state === "CORRECTED"
          );
        });
        if (filteredPss && filteredPss.length > 0) {
          let pss = filteredPss.filter(ps => {
            return (
              ps?.invoiceNumber &&
              ps?.invoiceDate &&
              ps?.invoiceTotal &&
              ps?.providedServiceDocument
            );
          });
          if (pss) {
            state.numOfCompletedProvidedServices = pss.length;
          }
        } else {
          state.numOfCompletedProvidedServices = 0;
        }
      } else {
        // If the bill has a state different to DRAFT or SENTBACK, assume that all the provided services are completed.
        state.numOfCompletedProvidedServices = state.numOfValidProvidedServices;
      }
    } else {
      state.numOfCompletedProvidedServices = 0;
    }
  },
  SET_VARIAZIONE_BILL_IN_DIALOG(state, result) {
    state.variazioneBillInDialog = result;
  },
  SET_ACTIVE_BILL_INFO(state, billInfo) {
    state.activeBillInfo = billInfo;
  },
  SET_ACTIVE_PROVIDED_SERVICE(state, providedService) {
    state.activeProvidedService = providedService;
  },
  updatePage(state, page) {
    state.pagination.page = page;
    state.pagination.isPaginationClicked = true;
  },
  updateSize(state, size) {
    state.pagination.size = size;
    state.pagination.isPaginationClicked = false;
  },
  setIsPaginationClicked(state, isPaginationClicked) {
    state.pagination.isPaginationClicked = isPaginationClicked;
  },
  setLastPathLocation(state, location) {
    state.lastPathLocation = location;
  },
  UPDATE_BILL_PROVIDED_SERVICE(state) {
    let updatedPs = state.activeProvidedService;
    // the bill may not exist (provided service state is PREBILL)
    if (state.activeBill?.providedServices) {
      let billPs = state.activeBill.providedServices.map(ps => {
        if (ps.providedServiceId === updatedPs.providedServiceId) {
          return {
            ...ps,
            state: updatedPs.state,
            invoiceDate: updatedPs.invoiceDate,
            invoiceNumber: updatedPs.invoiceNumber,
            invoiceTotal: updatedPs.invoiceTotal,
            invoiceDocument: updatedPs.invoiceDocument,
            prescriptionDocument: updatedPs.prescriptionDocument,
            providedServiceDocument: updatedPs.providedServiceDocument
          };
        }
        return ps;
      });
      state.activeBill.providedServices = billPs;
    } else {
      state.activeBill = {};
      state.activeBill.providedServices = [];
      state.activeBill.providedServices.push(updatedPs);
    }
  },
  ADD_BILL_PROVIDED_SERVICE(state, appointment) {
    let updatedPs = state.activeProvidedService;
    let psToAdd = {
      ...updatedPs,
      actualPageNumber: 0,
      appointmentDeliveryDate: appointment.appointmentDeliveryDate,
      appointmentScheduleDate: appointment.appointmentScheduleDate,
      coveredByFund: appointment.coveredByFund,
      doctorName: appointment.doctorName,
      doctorSurname: appointment.doctorSurname,
      expectedPageNumber: 3,
      iupCode: appointment.iupCode,
      memberName: appointment.memberName,
      memberSurname: appointment.memberSurname,
      price: appointment.price,
      protocolCode: appointment.protocolCode,
      serviceName: appointment?.hService?.longDescr || appointment?.serviceName
    };
    state.activeBill.providedServices.push(psToAdd);
  },
  REMOVE_BILL_PROVIDED_SERVICE(state, appointmentId) {
    let psIndex = state.activeBill.providedServices.findIndex(ps => {
      return ps.appointmentId === appointmentId;
    });
    state.activeBill.providedServices.splice(psIndex, 1);
  },
  SET_COUNT_BILLS(state, result) {
    if (result.type === "DRAFT") {
      state.numbOfDraftBills = result.num;
    }
    if (result.type === "SENTBACK") {
      state.numbOfSentBackBills = result.num;
    }
  }
};

const actions = {
  async createBill({ commit, dispatch, rootGetters }) {
    try {
      let officeId = rootGetters["hfManagement/officeId"];
      let bill = await services.billsService.createBill(officeId);
      if (bill) {
        commit("SET_ACTIVE_BILL_ID", bill.billId);
        await dispatch("getBill");
      }
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "bills";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  getBillsCount({ commit }, payload) {
    return services.billsService
      .getBillsCount(payload)
      .then(numberOfBills => {
        let result = { type: payload.state, num: numberOfBills };
        commit("SET_COUNT_BILLS", result);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "bills";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  },
  getItems({ commit, state }, officeId) {
    let payload = {};
    let dateFormat = "YYYY-MM-DD";
    if (state.pagination.isPaginationClicked === false) {
      commit("updatePage", 1);
      commit("setIsPaginationClicked", null);
    }

    if (state.sortConfig.sortBy) {
      payload.order = state.sortConfig.descending[0] ? "DESC" : "ASC";
      payload.orderField = state.sortConfig.sortBy[0];
    }

    if (state.pagination.page) payload.page = state.pagination.page - 1;
    if (state.pagination.size) payload.size = state.pagination.size;

    if (state.multiSelectConfig.activeItems.length > 0)
      payload.state = state.multiSelectConfig.activeItems.join(",");
    else payload.state = state.multiSelectConfig.items.join(",");

    if (state.dateConfig.range.dateFrom)
      payload.fromDate = dayjs(state.dateConfig.range.dateFrom).format(
        dateFormat
      );

    if (state.dateConfig.range.dateTo)
      payload.toDate = dayjs(state.dateConfig.range.dateTo).format(dateFormat);

    payload.dateToUse = state.dateConfig.dateToUse;
    if (state.toSearch) payload.toSearch = state.toSearch;

    payload.type = "BILLS";

    return services.billsService
      .fetchBills(officeId, payload)
      .then(billObj => {
        commit("SET_BILLS", billObj.billList);
        commit("SET_NUMBER_OF_BILLS", billObj.numberOfBills);
      })
      .catch(error => {
        commit("SET_BILLS", []);
        commit("SET_NUMBER_OF_BILLS", 0);
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "bills";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {
        commit("SET_FILTER_CRITERIA_RESULTS");
        commit("SET_ACTIVE_BILL_ID", null);
        commit("SET_ACTIVE_BILL", null);
        commit("SET_VALID_PROVIDED_SERVICES");
        commit("SET_NUM_OF_COMPLETED_PROVIDED_SERVICES");
      });
  },
  async getBill({ commit, getters, rootGetters }) {
    let officeId = rootGetters["hfManagement/officeId"];
    let BILL_ID = getters["activeBillId"];
    if (BILL_ID) {
      let responseObj = await services.billsService.fetchBillDetailsById(
        officeId,
        BILL_ID
      );
      let bTypes = ["POSITIVEVARIATION", "ZEROVARIATION", "NEGATIVEVARIATION"];
      if (responseObj.bill.billType === "VARIED") {
        let payload = filterProvidedServicesOfVariedBill(
          responseObj.bill,
          responseObj.relatedBills
        );
        commit("SET_ACTIVE_BILL", payload);
        commit("SET_VALID_PROVIDED_SERVICES");
        commit("SET_NUM_OF_COMPLETED_PROVIDED_SERVICES");
      } else if (bTypes.includes(responseObj.bill.billType)) {
        let bill2 = responseObj.bill;
        let pr2a = responseObj.bill.providedServices[0];
        let pr2b = { ...pr2a };
        let bill1 = responseObj.relatedBills[0];
        let pr1 = bill1.providedServices.find(ps => {
          return ps.providedServiceId === pr2a.variationOf;
        });
        pr2a["originalCoveredByFund"] = pr2a.coveredByFund;
        pr2a["coveredByFund"] = bill2.amount;
        let obj1 = {
          providedServiceId: pr1.providedServiceId,
          appointmentId: pr1.appointmentId,
          iupCode: pr1.iupCode,
          serviceName: pr1.serviceName,
          member: pr1.memberName.concat(" ").concat(pr1.memberSurname),
          price: pr1.price,
          coveredByFund: pr1.coveredByFund,
          invoiceNumber: pr1.invoiceNumber,
          invoiceDate: pr1.invoiceDate,
          billId: bill1.id,
          billType: bill1.billType,
          protocolCode: bill1.protocolCode,
          cro: bill1.cro
        };
        let obj2 = {
          providedServiceId: pr2b.providedServiceId,
          appointmentId: pr2b.appointmentId,
          iupCode: pr2b.iupCode,
          serviceName: pr2b.serviceName,
          member: pr2b.memberName.concat(" ").concat(pr2b.memberSurname),
          price: pr2b.price,
          coveredByFund: pr2b.coveredByFund,
          invoiceNumber: pr2b.invoiceNumber,
          invoiceDate: pr2b.invoiceDate,
          billId: bill2.id,
          billType: bill2.billType,
          protocolCode: bill2.protocolCode,
          cro: bill2.cro
        };
        let result = {};
        let prResult = [];
        prResult.push(obj1);
        prResult.push(obj2);
        result["incomingBill"] = bill2;
        result["pr2"] = pr2a;
        result["relatedPr"] = prResult;
        commit("SET_VARIAZIONE_BILL_IN_DIALOG", result);
        commit("SET_ACTIVE_BILL", responseObj);
        commit("SET_VALID_PROVIDED_SERVICES");
        commit("SET_NUM_OF_COMPLETED_PROVIDED_SERVICES");
      } else {
        commit("SET_ACTIVE_BILL", responseObj);
        commit("SET_VALID_PROVIDED_SERVICES");
        commit("SET_NUM_OF_COMPLETED_PROVIDED_SERVICES");
      }
    }
  },

  getBillsByCro({ commit }, payload) {
    commit("SET_ACTIVE_PROVIDED_SERVICE", null);
    let officeId = payload.officeId;
    let cro = payload.cro;

    return services.billsService
      .fetchBillsByCro(officeId, cro)
      .then(billObj => {
        let res = billObj.billServices.map(bill => bill);
        commit("SET_ACTIVE_PROVIDED_SERVICE", res);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "bills";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject(error);
      })
      .finally(() => {});
  },

  removeAppointmentFromBill(
    { commit, dispatch, rootGetters },
    { billId, appointmentId, deleteBill }
  ) {
    let officeId = rootGetters["hfManagement/officeId"];
    return services.billsService
      .removeAppointmentFromBill(officeId, billId, appointmentId)
      .then(() => {
        commit("REMOVE_BILL_PROVIDED_SERVICE", appointmentId);
        if (deleteBill) {
          router.push({
            name: "_bills"
          });
        } else {
          dispatch("reloadBillAndProvidedServices");
        }
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "bills";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject(error);
      })
      .finally(() => {});
  },
  addBillDocument({ commit, rootGetters }, { billId, document }) {
    let officeId = rootGetters["hfManagement/officeId"];
    return services.billsService
      .uploadDocument(officeId, billId, document)
      .then(data => {
        return Promise.resolve(data);
      })
      .catch(() => {
        let errorDialogDetails = {
          title: "bills.bill.documentsSection.errors.uploadFile.title",
          msg: "bills.bill.documentsSection.errors.uploadFile.genericMsg",
          actionBtn: "backButton",
          type: Utils.errorTypes.CUSTOM
        };
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  },
  removeDocumentFromBill({ commit, dispatch, rootGetters }, payload) {
    let officeId = rootGetters["hfManagement/officeId"];
    payload.officeId = officeId;
    return services.billsService
      .callRemoveDocumentFromBill(payload)
      .then(response => {
        dispatch("getBill");
        return response;
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "bills";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject(error);
      })
      .finally(() => {});
  },
  addNoteToBill({ commit, rootGetters, dispatch }, payload) {
    try {
      let officeId = rootGetters["hfManagement/officeId"];
      // add officeId to payload
      payload.officeId = officeId;
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      services.billsService.callAddNoteToBill(payload);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let success = {
        title: "bills.bill.addNoteBillDialog.success.title",
        message: "bills.bill.addNoteBillDialog.success.text-".concat(
          payload.billNote.noteType
        ),
        closeButtonLabel: "closeButton",
        closeButtonClb: () => {
          dispatch("getBill");
        }
      };
      commit("success/openSuccessDialog", success, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
      throw reason;
    }
  },
  sendBill({ commit, rootGetters }, { billId, pushWhere }) {
    let officeId = rootGetters["hfManagement/officeId"];
    return services.billsService
      .sendBill(officeId, billId)
      .then(data => {
        let office = rootGetters["hfManagement/selectedHfOffice"];
        let success = {
          title: "bills.bill.sendBillDialogs.sendSuccessful.title",
          message: "bills.bill.sendBillDialogs.sendSuccessful.text",
          params: { msg: { email: office.financialManager.email } },
          closeButtonLabel: "closeButton",
          closeButtonClb: () => {
            router.push(pushWhere);
          }
        };
        setTimeout(() => {
          commit("success/openSuccessDialog", success, {
            root: true
          });
        }, 200);
        return Promise.resolve(data);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "bills";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject(error);
      })
      .finally(() => {});
  },
  async saveAppointmentInvoiceInfo(
    { commit, dispatch, rootGetters },
    { appointmentId, invoiceNumber, invoiceDate, invoiceTotal }
  ) {
    try {
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      let officeId = rootGetters["hfManagement/officeId"];
      // fondoest/issues#981: if the value contains only letters, is not allowed
      let invNumber = invoiceNumber;
      if (/^[a-zA-Z]+$/.test(invNumber)) {
        invNumber = "";
      }
      let invTotal = invoiceTotal == "" ? null : invoiceTotal;
      await services.billsService.callSaveAppointmentInvoiceInfo(
        officeId,
        appointmentId,
        invNumber,
        invoiceDate,
        invTotal
      );
      await dispatch("getProvidedServiceById", appointmentId);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (error) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...error
      };
      errorDialogDetails.type = Utils.errorTypes.STATUS;
      errorDialogDetails.dataName = "bills";
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  getProvidedServiceById({ commit, rootGetters }, appointmentId) {
    commit("SET_ACTIVE_PROVIDED_SERVICE", null);
    commit("SET_ACTIVE_BILL_INFO", null);
    let officeId = rootGetters["hfManagement/officeId"];
    return services.billsService
      .callGetProvidedServiceById(officeId, appointmentId)
      .then(result => {
        commit("SET_ACTIVE_BILL_INFO", result.bill);
        commit("SET_ACTIVE_PROVIDED_SERVICE", result.providedService);
        commit("UPDATE_BILL_PROVIDED_SERVICE");
        commit("SET_VALID_PROVIDED_SERVICES");
        commit("SET_NUM_OF_COMPLETED_PROVIDED_SERVICES");
        return Promise.resolve();
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  async addProvidedServiceToBill({ commit, rootGetters }, appointment) {
    commit("SET_ACTIVE_PROVIDED_SERVICE", null);
    commit("SET_ACTIVE_BILL_INFO", null);
    let officeId = rootGetters["hfManagement/officeId"];
    let appId = appointment.appointmentId;
    return await services.billsService
      .callGetProvidedServiceById(officeId, appId)
      .then(result => {
        commit("SET_ACTIVE_BILL_INFO", result.bill);
        commit("SET_ACTIVE_PROVIDED_SERVICE", result.providedService);
        commit("ADD_BILL_PROVIDED_SERVICE", appointment);
        return Promise.resolve();
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  async reloadBillAndProvidedServices({ commit }) {
    commit("SET_VALID_PROVIDED_SERVICES");
    commit("SET_NUM_OF_COMPLETED_PROVIDED_SERVICES");
  },
  async getProvidedServicesFromVariazione({ commit, getters }, payload) {
    commit("loading/OPEN_LOADING_DIALOG", null, {
      root: true
    });
    let bill1 = getters["activeBill"];
    let pr1 = findBillProvidedServicesByIdWithVariationOf(bill1, payload.vOfId);
    let bill2 = findRelatedBillByProvidedServiceId(bill1, payload.psId);
    let pr2 = bill2.providedService;
    let bill3 = findRelatedBillByCreditNoteOfWithVariationOf(
      bill1,
      pr2.variationOf
    );
    let pr3 = bill3 ? bill3.providedService : null;
    let obj1 = {
      providedServiceId: pr1.providedServiceId,
      appointmentId: pr1.appointmentId,
      iupCode: pr1.iupCode,
      serviceName: pr1.serviceName,
      member: pr1.memberName.concat(" ").concat(pr1.memberSurname),
      price: pr1.price,
      coveredByFund: pr1.coveredByFund,
      invoiceNumber: pr1.invoiceNumber,
      invoiceDate: pr1.invoiceDate,
      billId: bill1.id,
      billType: bill1.billType,
      protocolCode: bill1.protocolCode,
      cro: bill1.CRO
    };
    let obj2 = {
      providedServiceId: pr2.providedServiceId,
      appointmentId: pr2.appointmentId,
      iupCode: pr2.iupCode,
      serviceName: pr2.serviceName,
      member: pr2.memberName.concat(" ").concat(pr2.memberSurname),
      price: pr2.price,
      coveredByFund: bill2.amount,
      invoiceNumber: pr2.invoiceNumber,
      invoiceDate: pr2.invoiceDate,
      billId: bill2.billId,
      billType: bill2.billType,
      protocolCode: bill2.protocolCode,
      cro: bill2.cro
    };
    let obj3 = null;
    if (bill3 && pr3) {
      obj3 = {
        providedServiceId: pr3.providedServiceId,
        iupCode: pr3.iupCode,
        serviceName: pr3.serviceName,
        member: pr3.memberName.concat(" ").concat(pr3.memberSurname),
        price: pr3.price,
        coveredByFund: bill3.amount,
        invoiceNumber: pr3.invoiceNumber,
        invoiceDate: pr3.invoiceDate,
        billId: bill3.billId,
        billType: bill3.billType,
        protocolCode: bill3.protocolCode,
        cro: bill3.cro
      };
    }
    let result = {};
    let prResult = [];
    prResult.push(obj1);
    if (obj3) {
      prResult.push(obj3);
    }
    prResult.push(obj2);
    result["incomingBill"] = bill1;
    result["pr2"] = pr2;
    result["relatedPr"] = prResult;
    commit("SET_VARIAZIONE_BILL_IN_DIALOG", result);
    commit("loading/CLOSE_LOADING_DIALOG", null, {
      root: true
    });
  },
  resetProvidedServicesFromVariazione({ commit }) {
    commit("loading/OPEN_LOADING_DIALOG", null, {
      root: true
    });
    commit("SET_VARIAZIONE_BILL_IN_DIALOG", {});
    commit("loading/CLOSE_LOADING_DIALOG", null, {
      root: true
    });
  }
};

function filterProvidedServicesOfVariedBill(bill, relatedBills) {
  let bPs = bill.providedServices;
  let variedPss = [];
  let mappedRBillsWithPss = [];
  // find all the VARIATED pss of the requested bill
  let variatedPss = bPs.filter(ps => {
    return ps.state === "VARIATED";
  });
  // search into relatedBills to get the varied ps that match ps1.variedBy == ps2.providedServiceId
  relatedBills.forEach(rb =>
    rb.providedServices.filter(rbPs => {
      let found = variatedPss.find(vPs => {
        return vPs.variedBy === rbPs.providedServiceId;
      });
      if (found) {
        variedPss.push(rbPs);
      }
    })
  );
  // create a list of object with related bill property and its provided service property
  relatedBills.forEach(rb =>
    mappedRBillsWithPss.push({
      billId: rb.id,
      protocolCode: rb.protocolCode,
      billType: rb.billType,
      amount: rb.amount,
      cro: rb.CRO,
      providedService: rb.providedServices[0],
      providedServiceId: rb.providedServices[0].providedServiceId,
      variationOf: rb.providedServices[0].variationOf,
      creditNoteOf: rb.providedServices[0].creditNoteOf
    })
  );
  // remove from the requested bill its VARIATED pss
  let variatedPsIds = variatedPss.map(x => {
    return x.providedServiceId;
  });
  bPs = bPs.filter(ps => {
    return !variatedPsIds.includes(ps.providedServiceId);
  });
  bill["filteredProvidedServices"] = bPs;
  bill["variedProvidedServices"] = variedPss;
  bill["mappedRelatedBillsWithProvidedService"] = mappedRBillsWithPss;
  return { bill: bill, relatedBills: relatedBills };
}

function findBillProvidedServicesByIdWithVariationOf(bill, vOfId) {
  let bPs = bill.providedServices;
  return bPs.find(ps => {
    return ps.providedServiceId === vOfId;
  });
}

function findRelatedBillByProvidedServiceId(bill, psId) {
  let mrb = bill.mappedRelatedBillsWithProvidedService;
  return mrb.find(b => {
    return b.providedServiceId === psId;
  });
}

function findRelatedBillByCreditNoteOfWithVariationOf(bill, vOfId) {
  let mrb = bill.mappedRelatedBillsWithProvidedService;
  return mrb.find(b => {
    return b.creditNoteOf === vOfId;
  });
}

function applyAlphabeticOrderOnProvidedServices(providedServices) {
  return providedServices.sort(
    (a, b) =>
      a.serviceName.localeCompare(b.serviceName) ||
      a.providedServiceId.localeCompare(b.providedServiceId)
  );
}

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
